import { render, staticRenderFns } from "./Concept.vue?vue&type=template&id=2596c60e&scoped=true&"
import script from "@/views/Concept/Concept.ts?vue&type=script&lang=ts&"
export * from "@/views/Concept/Concept.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Concept/Concept.scss?vue&type=style&index=0&id=2596c60e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2596c60e",
  null
  
)

export default component.exports